import { render, staticRenderFns } from "./MultipleAutobuyersBox.vue?vue&type=template&id=0fd417d9&scoped=true"
import script from "./MultipleAutobuyersBox.vue?vue&type=script&lang=js"
export * from "./MultipleAutobuyersBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd417d9",
  null
  
)

export default component.exports